import React from "react";
import SectionHeader from "../components/section/SectionHeader";
import NewOrganizationMappingForm from "../components/organizationMapping/NewOrganizationMappingForm";
import { CREATE_ORG_MAPPING_TRANSLATIONS } from "../translations/util";

const NewOrganizationMapping = () => {
  return (
    <>
      <SectionHeader
        pageTitle={CREATE_ORG_MAPPING_TRANSLATIONS.header}
        pageDescription={CREATE_ORG_MAPPING_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={<div className="dropdown-details" />}
      />

      <div className="main-content">
        <NewOrganizationMappingForm />
      </div>
    </>
  );
};

export default NewOrganizationMapping;
